import * as actionType from './ActionType';

export const setStep03 = (data) => ({
  type: actionType.SET_VALUE_STEP03,
  payload: data
});
